import React from 'react';

export default function Details() {
  return (
    <svg
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <rect width='24' height='24' rx='12' fill='#18181B' />
      <path
        d='M9.33333 8H18M9.33333 12H18M9.33333 16H18M6 8H6.00667M6 12H6.00667M6 16H6.00667'
        stroke='#A1A1AA'
        stroke-width='1.25'
        stroke-linecap='round'
        stroke-linejoin='round'
      />
    </svg>
  );
}
